import {Link, NavLink} from "react-router-dom";
import React, {Fragment, useRef} from "react";

import {
    FormatNumberByhkh,
} from "../../clientconfigwebapp";

import '../assets/css/Order_view.css';

import {Icon_Address_loc, Icon_box, Icon_dollar, Icon_Truck, Icon_User_info} from '../../assets/icones/icones';




const Order_View_Factor_components = (props) => {

    ///let link_post_get="/"+props.link_to;
    //link_post_get=link_post_get.replaceAll("//","")

///console.log(props.data_info_get,"props.data_info_get")


    return (
        <Fragment>
            <div className='w-100'>

                {
                    String(props.data_info_get).length  > 0 ?  (


              <Fragment>

                  <div className="box-cart-track">
                      <div style={{border: "solid 1px #dfd9d9", borderRadius: 5, padding: 10}}>

                          <div style={{padding: "13px 10px 13px 10px"}}><span style={{fontWeight: "bold", fontSize: 15, color: "color: var(--c7);"}}>جزئیات سفارش : {props.data_info_get.id_order}</span></div>


                          <div style={{paddingRight: 11, paddingLeft: 11}}>
                              <span style={{paddingLeft: 5}}><Icon_Truck /></span>

                              <span style={{"display": "inline-block", "fontFamily": "'Kalameh'", "fontSize": "13px", "color": "var(--c7)"}}>آخرین وضعیت این سفارش</span>


                              <span style={{
                                  "color": "white",
                                  "padding": "5px",
                                  "borderRadius": "4px",
                                  "backgroundColor": "green",
                                  "fontFamily": "'iran'",
                                  "marginRight": "11px"
                              }}>{String(props.data_info_get.status_pay_text)}</span>
                          </div>
                          <div style={{
                              "padding": "13px 10px",
                              "backgroundColor": "rgb(237, 237, 237)",
                              "display": "flex",
                              "margin": "7px",
                              "borderRadius": "13px",
                              "flexDirection": "row",
                              "flexWrap": "wrap",
                              "alignContent": "center",
                              "justifyContent": "space-between",
                              "alignItems": "center",
                              "marginTop": "23px"
                          }}>
                              <div className=" right-box-price-order-detbk">
        <span style={{"lineHeight":"1.6","paddingBottom":"5px","paddingTop":"5px"}}>مبلغ پرداختی سفارش :{FormatNumberByhkh(String(props.data_info_get.price), ".", ",")}</span>
                              </div>


                              <div
                                  className=" left-box-price-order-detbk"
                                  style={{textAlign: "left","lineHeight":"1.6","paddingBottom":"5px","paddingTop":"5px"}}
                              >
                                  تاریخ ثبت سفارش : {props.data_info_get.date_fa}
                              </div>
                          </div>


                          <div style={{display: "none", padding: "11px 10px 7px 10px", backgroundColor: "transparent"}}><Icon_Address_loc /><span className="address-order-delv" style={{fontSize: 12, lineHeight: "1.7", display: "inline-block"}}>آدرس:</span></div>



                          <div className="box_info_name_user_order" style={{
                              display: 'flex',
                              direction: 'rtl',
                              paddingRight: '11px',
                              paddingLeft: '11px',
                              alignItems: 'center',
                              alignContent: 'center',
                              justifyContent: 'flex-start',
                              flexWrap: 'nowrap',
                              flexDirection: 'row',
                          }}>
                              <div className="item_order_info_user" style={{display: "none"}}>
                                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                       stroke="#b3b3b3" style={{
                                      width: '22px',
                                      height: '21px',
                                      display: 'inline-block',
                                      position: 'relative',
                                      top: '5px'
                                  }}>
                                      <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                      <g id="SVGRepo_iconCarrier">
                                          <path
                                              d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                                              stroke="b3b3b3" strokeWidth={2} strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                          <path
                                              d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                                              stroke="b3b3b3" strokeWidth={2} strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                      </g>
                                  </svg>
                                  <span style={{fontSize: '12px', paddingRight: '7px'}}>کد پستی: </span>
                              </div>


                              <div className="item_order_info_user">
                                <Icon_User_info />
                                  <span style={{
                                      fontSize: '11px',
                                      paddingRight: '7px'
                                  }}>{props.data_info_get.first_and_last_name_ord}</span>

                              </div>


                              <div className="item_order_info_user">
<Icon_box />
                                  <span style={{
                                      fontSize: '11px',
                                      paddingRight: '7px'
                                  }}>{props.data_info_get.delivery_method_show}</span>

                              </div>


                          </div>

                          <div className="box_info_name_user_order" style={{
                              display: 'flex',
                              direction: 'rtl',
                              paddingRight: '11px',
                              paddingLeft: '11px',
                              alignItems: 'center',
                              alignContent: 'center',
                              justifyContent: 'flex-start',
                              flexWrap: 'nowrap',
                              flexDirection: 'row',
                          }}>

                              <div className="item_order_info_user">
                                  <Icon_box/>
                                  <span style={{
                                      fontSize: '11px',
                                      paddingRight: '7px'
                                  }}>هزینه ارسال : {FormatNumberByhkh(String(props.data_info_get.shipping_cost), ".", ",")}</span>

                              </div>

                              <div className="item_order_info_user">
                                  <Icon_dollar/>
                                  <span style={{
                                      fontSize: '11px',
                                      paddingRight: '7px'
                                  }}> ارزش افزوده : {FormatNumberByhkh(String(props.data_info_get.price_tax), ".", ",")}</span>

                              </div>

                          </div>


                          <div className="box_info_name_user_order" style={{
                              display: 'flex',
                              direction: 'rtl',
                              paddingRight: '11px',
                              paddingLeft: '11px',
                              alignItems: 'center',
                              alignContent: 'center',
                              justifyContent: 'flex-start',
                              flexWrap: 'nowrap',
                              flexDirection: 'row',
                          }}>
                              <div className="item_order_info_user" style={{"borderTop":"solid 1px #cdcbcb82","paddingTop":"16px"}}>
                                  <Icon_dollar/>
                                  <span style={{
                                      fontSize: '11px',
                                      paddingRight: '7px'
                                  }}>جمع ایتم های سبد خرید : {FormatNumberByhkh(String(props.totalPrice), ".", ",")}</span>

                              </div>
                          </div>


                      </div>


                  </div>


              </Fragment>


                    ) : (


                        <React.Fragment>
                            فاکتور یافت نشد
                        </React.Fragment>


                    )}

            </div>
        </Fragment>
    );

}
export default Order_View_Factor_components;

